import { render, staticRenderFns } from "./RectangleCoordinatableObjectsTransformer.vue?vue&type=template&id=3b8f53de&"
import script from "./RectangleCoordinatableObjectsTransformer.vue?vue&type=script&lang=ts&"
export * from "./RectangleCoordinatableObjectsTransformer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports